import {useEffect, useState} from "react";
import {useViewerStore} from "../../../store/store";
import { AlertType } from "../../../@types/enums";

type MessageAlertProps = {
    message: string,
    messageType: any,
    setState: any
}

const MessageAlert = (props: MessageAlertProps) => {

    const {message, messageType, setState} = props;
    const sceneViewer = useViewerStore(state => state.sceneViewer);
    const viewerAlert = useViewerStore(state => state.viewerAlert);
    const [alertPosition, setAlertPosition] = useState<{ top: number; left: number } | null>(null);

    useEffect(() => {
        const toastElement = document.getElementById("three-js-toast");
        if(!toastElement) return;

        const removeClasses = () => {
            toastElement.classList.remove(
                ...[
                    "ma-three-positive",
                    "ma-three-negative",
                    "ma-three-warning-message",
                    "ma-three-info",
                ]
            );
        };

        removeClasses();

        switch (messageType) {
            case AlertType.success:
                toastElement.classList.add("ma-three-positive");
                break;
            case AlertType.error:
                toastElement.classList.add("ma-three-negative");
                break;
            case AlertType.warning:
                toastElement.classList.add("ma-three-warning-message");
                break;
            case AlertType.info:
                toastElement.classList.add("ma-three-info");
                break;
            default:
                toastElement.classList.add("ma-three-info");
                break;
        }
    }, [viewerAlert]);

    const closeThreeJSAlert = () => {
        sceneViewer.removeViewerAlert()
        setState(false);
    };

    useEffect(() => {
        setTimeout(closeThreeJSAlert, 6000);
    }, []);

    useEffect(() => {
        const updateAlertPosition = () => {
            const canvasContainer = document.getElementById("canvasContainer");
            if (!canvasContainer) {
                setAlertPosition(null);
                return;
            }
            const canvasRect = canvasContainer.getBoundingClientRect();
            setAlertPosition({
                top: Math.max(canvasRect.top + 12, 8),
                left: canvasRect.left + canvasRect.width / 2,
            });
        };

        updateAlertPosition();
        window.addEventListener("resize", updateAlertPosition);
        return () => window.removeEventListener("resize", updateAlertPosition);
    }, [viewerAlert.show]);

    return (
        <div
            id={"three-js-toast"}
            className={`alert ${viewerAlert && "open"} three-warning`}
            style={alertPosition ? { top: `${alertPosition.top}px`, left: `${alertPosition.left}px` } : undefined}
        >
            <p className="alert__content-message">{message}</p>
        </div>
    );
};

export default MessageAlert;